module.exports = "images/soundOffFocus.e89e4732.png";